import { color, font, space, query } from '@design/templateFns';
import styled from 'styled-components';
import { FavoriteButton } from '@components/MiscComponents/FavoriteButton';

export const MapWrapper = styled.div<{ $isMarkerHover?: boolean }>`
  position: ${({ $isMarkerHover }) => ($isMarkerHover ? '' : 'relative')};
  .map-container {
    height: calc(100vh - 264px);
    width: 100%;
  }
  .cluster {
    position: absolute;
    background: #c7050a;
    border-radius: 50%;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    border: 4px solid #fff;
    img {
      // Hides default style
      display: none;
    }
    div {
      // Font stylings
      color: #fff !important;
      font-size: 18px !important;
    }
  }
`;

export const Headline = styled.h1`
  ${font('subhead-sm')};
  padding-bottom: 0;
  margin-bottom: 18px;
  width: fit-content;
  @media screen and (${query.below('tablet')}) {
    font-size: 14px;
  }
`;

export const InfoBoxDescription = styled.p`
  ${font('body-md-light')};
  color: ${color('gray4')};
  max-width: 368px;
  padding: 0;
  > strong {
    font-weight: 700;
    color: ${color('fg')};
  }
`;
export const StyledInfoBoxMain = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${space('lg')};
`;
export const StyledInfoBoxCol = styled.div`
  flex: 1 0 0%;
  width: 100%;
`;

export const StyledInfoBoxImage = styled.div`
  flex: 0 0 auto;
  width: 88px;

  img {
    object-fit: cover;
  }

  @media screen and (${query.atLeast('tablet')}) {
    width: 135px;
  }
`;
export const EmptyImagePlaceholder = styled.div`
  width: 88px;
  height: 88px;
  background-color: ${color('gray1')};
  @media screen and (${query.atLeast('tablet')}) {
    width: 135px;
    height: 135px;
  }
`;

export const InfoHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${space('lg')};
  align-items: center;
`;
export const InfoHeadline = styled.h3`
  ${font('subhead-md')}
  padding: 0;
  @media screen and (${query.below('tablet')}) {
    ${font('subhead-sm')}
  }
  a {
    color: ${color('fg')};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const InfoItems = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 22px;
  color: ${color('gray4')};
  max-width: 213px;
  padding: 0;
  padding-bottom: ${space('md')};

  > span {
    margin-right: ${space('md')};
    display: inline-block;
    line-height: 1;

    & + &::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      margin-right: ${space('md')};
      width: 4px;
      height: 4px;
      background-color: ${color('gray2')};
      border-radius: 100%;
    }
  }
  @media screen and (${query.below('tablet')}) {
    font-size: 14px;
  }
  a {
    color: ${color('fg')};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
export const FooterInfo = styled.p`
  font-size: 12px;
  line-height: 14px;
  font-weight: 300;
  padding: 0;
  color: ${color('gray4')};
`;

export const StyledFavoriteButton = styled(FavoriteButton)`
  display: inline-block;
`;
